import { DTOTarif } from '../dto/tarif.dto';

export class VOTarif {
    dto: DTOTarif;
    flag_editable: boolean;
}